import React, {useContext, useState} from "react";
import {ModalContext, ModalDispatch} from "../context/ModalContext";
import WCLoginService from "../services/WCLoginService";
import {LoaderDispatch} from "../context/LoaderContext";

const PasswordChangeForm = ({email}) => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const modal = useContext(ModalContext);
    const modalDispatch = useContext(ModalDispatch);
    const loaderDispatch = useContext(LoaderDispatch);
    const handleChangePassword = async (e) => {
        e.preventDefault();
        loaderDispatch({type: 'activate'});
        modalDispatch({type: 'clear'});

        if (password !== confirmPassword) {
            modalDispatch({
                type: 'setErrorMsg',
                payload: 'Podane hasła nie są identyczne.'
            });
            return;
        }

        if(password.length < 8) {
            modalDispatch({
                type: 'setErrorMsg',
                payload: 'Hasło musi mieć minimum 8 znaków.'
            });
            return;
        }

        const response = await WCLoginService.resetPassword(email, password);

        if(response.status === 'error') {
            modalDispatch({
                type: 'setErrorMsg',
                payload: response.message
            });
        } else {
            modalDispatch({
                type: 'setSuccessMsg',
                payload: response.message
            });
            modalDispatch({type: 'setModalContent', payload: {content: '' , title: 'Hasło zresetowano'}});
        }
        loaderDispatch({type: 'deactivate'});
    }

    return (
        <form onSubmit={handleChangePassword} aria-label="Formularz zmiany hasła">
            <div className="mb-3">
                <label htmlFor="password" className="form-label">Hasło</label>
                <input
                    type="password"
                    className="form-control"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    aria-required="true"
                    aria-label="Hasło"
                    autoComplete="new-password"
                />
            </div>
            <div className="mb-3">
                <label htmlFor="confirmPassword" className="form-label">Potwierdź hasło</label>
                <input
                    type="password"
                    className="form-control"
                    id="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                    aria-required="true"
                    aria-label="Potwierdź hasło"
                    autoComplete="new-password"
                />
            </div>
            <button type="submit" className="btn btn-primary" aria-label="Zmień hasło">Zmień hasło</button>
        </form>
    )
}

export default PasswordChangeForm;
